import { EntityType } from '@frontend/common';
import { ErrorHandler } from '@frontend/error-handler';
import { ProductCategoryClient } from '@frontend/group/api';
import { Group } from '@frontend/group/utils';
import { useLocale } from '@frontend/lang';
import { useBlobRepository } from '@frontend/repository';
import { useEffect, useState } from 'react';

import ImagePlaceholder from '../../../../../assets/images/image-placeholder.png';
import { useAppSelector } from '../../../../redux/store';
import { CategoryCardProps } from './category-card.component';

export const useCategoryCard = (props: CategoryCardProps) => {
    const { locale } = useLocale();
    const navigationState = useAppSelector((state) => state.navigation);
    const blobRepository = useBlobRepository();
    const [category, setCategory] = useState(props.category || null);
    const [image, setImage] = useState<string | null>(null);

    useEffect(() => {
        if (!navigationState.iot) return;
        if (props.category_id && !props.category) {
            ProductCategoryClient.fetchProductCategory(navigationState.iot.account_id, props.category_id).then(setCategory);
        }
    }, [props.category_id, props.category, navigationState.iot]);
    useEffect(() => {
        if (!category) return;
        new Group(category)
            .getBlobImage(blobRepository, EntityType.PRODUCT_CATEGORY)
            .then((image) => {
                if (!image) setImage(ImagePlaceholder);
                else setImage(image);
            })
            .catch(ErrorHandler.handleError);
    }, [category]);

    return {
        category,
        image,
        locale
    };
};
